<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="pubGroupIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>公示公开</span></p></div>
          </div>
        </div>
    <!--    <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>-->
        <div class="wraper">
          <div class="publicity">
            <div class="nav">
              <ul>
<!--                <li><a href="javascript:void(0)" id="apply" class="on" @click="handleClick('apply','pay')">待遇申请</a></li>-->
                <li><a href="javascript:void(0)" id="pay" class="on" @click="handleClick('pay','apply')">资金发放</a></li>
              </ul>
            </div>
            <div class="division1">

              <span>公示单位：
          <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"  clearable placeholder="请选择公示单位" style="width: 160px;"></el-cascader>
          <!--<el-cascader :options="departOption" v-model="selecteddepartOption" clearable  placeholder="办事单位" style="width: 180px;display: none"></el-cascader>-->
          </span>
<!--              <span  v-if="tabSelect=='apply'" style="margin-left: 15px;">待遇类别：
           <el-cascader :options="dylbOption" v-model="selecteddylbOption" clearable  placeholder="待遇类别" style="width: 180px;" ></el-cascader></span>-->
              <span >公示期： <el-date-picker
                v-model="payMonth"
                type="daterange"
                align="left"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                style="width:260px"
              >
    </el-date-picker>

              </span>

              <span  > 公示标题：<el-input v-model="pname" placeholder="请输入公示标题" clearable style="width: 180px;"></el-input></span>
<!--              <span style="margin-left: 15px;"> 姓名：<el-input v-model="pname" placeholder="请输入姓名" clearable style="width: 180px;"></el-input></span>-->

              <span style="padding-left: 15px;"><el-button type="danger" @click="search()" icon="el-icon-search">搜索</el-button></span>
            </div>
            <table width="100%" border="0" cellspacing="1" cellpadding="0" v-if="tabSelect=='apply'">
              <tr class="first">
                <td >公示标题</td>
                <td width="150px">公示单位</td>
                <td width="300px">公示期</td>
                <td width="100px">公示状态</td>
                <td width="70">操作</td>
              </tr>
              <tr  v-for="(item,index) in dataObjList" :key="index">
                <td align="left" style="width: 384px" nowrap="true">&nbsp;{{item.pubDesc}}</td>
                <td align="left" nowrap="true">&nbsp; {{item.pubParty}}</td>
                <td align="center" nowrap="true">{{item.beginDate}}至{{item.endDate}}</td>
                <td align="center" nowrap="true">{{item.pubStatusName}}</td>
                <td align="center" nowrap="true">
                  <a href="javascript:void(0)" @click="urlTo('pubItemIndex',{type:1,pubId:item.pubId,pubDesc:item.pubDesc,pubParty:item.pubParty,beginDate:item.beginDate,endDate:item.endDate,pubPartyId:item.pubPartyId})"
                     style="color: #2162f0;">详情</a></td>
              </tr>
            </table >

            <table width="100%" border="0" cellspacing="1" cellpadding="0" v-if="tabSelect=='pay'">
              <tr class="first">
                <td >公示标题</td>
                <td width="150px">公示单位</td>
                <td width="300px">公示期</td>
                <td width="100px">公示状态</td>
                <td width="70">操作</td>

              </tr>
              <tr v-for="(item,index) in dataObjList" :key="index">
                <td align="left" style="width: 384px" nowrap="true">&nbsp;{{item.pubDesc}}</td>
                <td align="left" nowrap="true">&nbsp;  {{item.pubParty}}</td>
                <td align="center" nowrap="true">{{item.beginDate}}至{{item.endDate}}</td>
                <td align="center" nowrap="true">{{item.pubStatusName}}</td>

                <td align="center" nowrap="true">
                  <a href="javascript:void(0)"  @click="urlTo('pubItemIndex',{type:2,pubId:item.pubId,pubDesc:item.pubDesc,pubParty:item.pubParty,beginDate:item.beginDate,endDate:item.endDate,pubPartyId:item.pubPartyId})"
                     style="color: #2162f0;">详情</a></td>
              </tr>
            </table >

            <div style="text-align: center;height: 50px;line-height: 50px;" v-if="dataObjList.length>0"> <el-pagination
              layout="prev, pager, next"
              :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
            </el-pagination>
            </div></div>

        </div>

      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
let id = 0;

export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      dataObjList:[],
      itemMonth:'',
      active: 'publicIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      sj_str:'',
      type:'',
      pub_id:'',
      splitTest:"",
      week_str:'',
      itemData:null,
      tabSelect:'apply',
      pubTypeId:'apply',
      workDepartId:"",
      pageTotal:1,
      dataList:[],
      pname:"",
      payMonth:"",
      selectedRegion:[],
      selecteddepartOption:[],
      selecteddylbOption:[],
      departOption:[],
      dylbOption:[
        { value: 'BLAN', label: '城乡低保' },
        { value: 'CLP_LIV', label: '残疾人生活补贴' },
        { value: 'CLP_HLF', label: '残疾人护理补贴' },
        { value: 'NTF', label: '特困供养' },
        { value: 'TEMP', label: '临时救助' },
        { value: 'BLAN_ORP', label: '事实无人抚养儿童生活费' },
        { value: 'ORP', label: '分散养育孤儿' },
        { value: 'CUTTED', label: '精简退职' },
        { value: 'QYTC', label: '分散养育孤儿' },
        { value: 'ORP', label: '起义投诚' },
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      props: {
        lazy: true,
        checkStrictly:true,
        lazyLoad (node, resolve) {
          const {level} = node;
          var t=0;
          if(!node.value){
            node.value=_self.$cookies.get("areaRoot");
            t=1;
            //上级为空，默认设置大通县数据
          }
            const options = {pid: node.value}
          _self.$https.post("api/pu/getAreaByParentCode.do", options, response => {
            const nodes =[];
            // if(t==0) {
            //   if(node.value=='63010001'){
            //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
            //     resolve(nodes);
            //   }else{
                if (response.status === 200 && response.data.code === 200) {
                  const nodes = Object.values(response.data.data).map(function (e) {
                    return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                  })
                  resolve(nodes);
                } else {
                  resolve(nodes);
                }
              // }
            // }else{
            //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
            //   // resolve(nodes);
            //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
            //   resolve(nodes);
            // }
          })
        }
      },
      pageNum:1,
      pageSize:10,
    }
  } ,
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
    // selectedRegion(nv){
    //   this.workDepartId='';
    // if (nv.length>3){
    //   this.workDepartId=nv[3];
    // }
    // }
  },
  created(){
    this.initData();
    this.type = this.$route.query.type;
    this.browseLog('gkgs','dysqgs');
  },
  methods: {
    toLookApply(value){
      return '/pubItemIndex?type=1&&pubId='+value;
    },
    toLookPay(value){
      return '/pubItemIndex?type=2&&pubId='+value;
    },
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    search(){
      this.pageNum=1;
      this.dataObjList=[];
      this.initData();
    },
    initData(tts){
        var _wdid=this.workDepartId;
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        // if(_wdid==''){
        //   _wdid=this.old_party_id;
        // }
        const options={
          pname:this.pname,
          workDepartId:_wdid,
          pubTypeId:this.pubTypeId,
          itemMonth:this.itemMonth,
          payMonth:this.payMonth,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          length: this.selectedRegion.length,
        };
        var t=this;
        this.$https.post("api/pubItem/getPubItem.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            t.dataObjList=[];
            if(null != response.data.data && response.data.data.length>0){
              t.dataObjList=t.dataObjList.concat(response.data.data);
              // t.dataObjList.push(response.data.data);
              t.pageTotal=t.dataObjList[0].total;
            }
          } else {
            t.dataObjList=[];
          }
        })
    },

  getDepartAreas(ParentId,index){
    const options={pid:ParentId}
    var t=this;
    this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
      if (response.status === 200 && response.data.code===200) {
        t.departOption = Object.values(response.data.data).map(function(e){
          return {label:e.name,value:e.code,leaf:true}
        })
      } else {
        t.departOption =[];
      }
    })
  },
    handleClick(ontab,untab) {

      //异步获取数据
      if(this.tabSelect==ontab) {
        return;
      }
      this.tabSelect=ontab;
      $("#"+ontab).addClass("on");
      $("#"+untab).removeClass("on");
      if(ontab !='pay'){
        this.payMonth='';
      }
      if(ontab !='apply'){
        this.selecteddylbOption=[];
      }
      if (ontab==='pay'){
        this.pubTypeId='pay';
        this.browseLog('gkgs','zjffgs');
      }else if (ontab==='apply'){
        this.pubTypeId='apply';
        this.browseLog('gkgs','dysqgs');
      }
      this.pageNum=1;
      this.initData();
    },
    //当地区选择变化时
    onAreaChange(picker, values, index) {
      if (index < 2) {
        this.getAreas(values[index].code, index + 1);                        //传参 参数为上层选择的地区的code
      }
    },
    browseLog(one,two){
      const options={
        oneCode:one,
        twoCode:two,
      }
      this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
      })
    },
    onAreaConfirm(value) {
      var checkName="";
      if (value[0] && value[0].code) {
        checkName = value[0].name;
      }
      if (value[1] && value[1].code) {
        checkName= checkName+"/"+value[1].name;
      }
      if (value[2] && value[2].code) {
        checkName= checkName+"/"+value[2].name;
      }
      this.checkCity=checkName;
      this.areaDepartList[0].values=[];
      this.workDepart= '';
      this.workDepartId='';
      if (value[2] && value[2].code) {
        this.getDepartAreas(value[2].code,0);
      } else if (value[1] && value[1].code) {
        this.getDepartAreas(value[1].code,0);
      } else if (value[0] && value[0].code) {
        this.getDepartAreas(value[0].code,0);
      } else {
        // this.checkCity = null;
      }
      this.showPicker = false;
    },

    onAreaDepartConfirm(value){
      if(value && value[0]){
        this.workDepart= value[0].name;
        this.workDepartId=value[0].code;
      }this.showDepartPicker = false;
    },

    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PubGroupIndex.vue